import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import Paging from "components/common/paging";
import ParkingSpotPriceItem from './parkingSpotsPriceItem';
import CheckBox from 'components/common/checkbox/checkbox';
import ButtonText from 'components/common/buttonText'; // adjust path if needed

const ParkingSpotsPriceTable = ({
    parkingSpots,
    setParkingSpotForPrice,
    setShowEditPriceModal,
    onDeleteSpotPrice,
}) => {
    const [pages, setPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [spots, setSpots] = useState([]);
    const [selectedSpots, setSelectedSpots] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        if (parkingSpots?.length >= 0) {
            // Initialize spots with isChecked property
            setSpots(parkingSpots.map(ps => ({ ...ps, isChecked: ps.isChecked ?? false })));
            setPages(Math.ceil(parkingSpots.length / 10));
        }
    }, [parkingSpots]);

    useEffect(() => {
        // Update selectedSpots when spots change
        setSelectedSpots(spots.filter(s => s.isChecked));
    }, [spots]);

    const handleParkingSpotItemPrice = (parkingSpot) => {
        // Toggle isChecked for a single spot
        setSpots(prevSpots => prevSpots.map(s =>
            s.parkingSpotExtId === parkingSpot.parkingSpotExtId
                ? { ...s, isChecked: !s.isChecked }
                : s
        ));
    };

    const handleSelectAllParkingSpots = () => {
        const isAllChecked = spots.length > 0 && spots.every(s => s.isChecked);
        setSpots(prevSpots => prevSpots.map(s => ({ ...s, isChecked: !isAllChecked })));
    };

    const isAllChecked = spots.length > 0 && spots.every(s => s.isChecked);

    if (!spots) return null;

    const slice = spots.slice(currentPage * 10, currentPage * 10 + 10);

    return (
        <>
            <div className="mb-4 flex justify-end items-center">
                <ButtonText
                    onClick={() => {
                        if (selectedSpots.length > 0) {
                            setParkingSpotForPrice(selectedSpots);
                            setShowEditPriceModal(true);
                        }
                    }}
                    disabled={selectedSpots.length === 0}
                >
                    {t('parkingSpotsPricePage.bulkEditPrice')}
                </ButtonText>
            </div>
            <div className="-mr-6 -ml-6 airpark-scroll overflow-x-scroll">
                <table className="table-auto w-full">
                    <thead>
                        <tr className="text-left bg-airpark-gray-300 h-11">
                            <th className="pl-6">
                                <CheckBox isChecked={isAllChecked} onClick={handleSelectAllParkingSpots} />
                            </th>
                            <th className="pl-6">{t('parkingArea.id')}</th>
                            <th className="pl-6">{t('parkingArea.locationSpecific')}</th>
                            <th className="pl-6">{t('parkingArea.floor')}</th>
                            <th className="pl-6">{t('parkingArea.number')}</th>
                            <th className="pl-6">{t('parkingArea.objectId')}</th>
                            <th className="pl-6">{t('parkingArea.features')}</th>
                            <th className="pl-6">{t('parkingArea.price')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {slice.map((ps, i) => (
                            <ParkingSpotPriceItem
                                key={i}
                                parkingSpot={ps}
                                setParkingSpotForPrice={setParkingSpotForPrice}
                                setShowEditPriceModal={setShowEditPriceModal}
                                onDeleteSpotPrice={onDeleteSpotPrice}
                                handleParkingSpotItemPrice={handleParkingSpotItemPrice}
                            />
                        ))}
                    </tbody>
                </table>
            </div>

            {pages > 0 && (
                <Paging
                    totalNumberOfPages={pages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </>
    );
};

export default ParkingSpotsPriceTable;
